export const getHtmlId = (field, form, index =0 ) =>  `${form.form_name}_custom_answers_attributes_${index}_answer`;

export const getHtmlName = (field, form) =>  `${form.form_class}[${field.mapped_name}]`;
